export enum DepartmentStatus{
    ACTIVE='Active',
    DELETE='Removed',
    DISABLED='Disabled'
}